'use strict';

var rxjs = require('rxjs');
var axios = require('axios');
var qs = require('querystring');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var isNotNullish = function (value) {
    return typeof value !== 'undefined' && value !== null;
};
var AuthStorageWrapper = /** @class */ (function () {
    function AuthStorageWrapper(options) {
        var _this = this;
        this.clear = function () {
            _this.storage_().removeItem(_this.storageKey_);
        };
        this.get = function () {
            var value = _this.storage_().getItem(_this.storageKey_);
            if (isNotNullish(value) && value.length > 0) {
                try {
                    return _this.deserialize_(value);
                }
                catch (ignore) {
                    console.trace(ignore);
                }
            }
            return undefined;
        };
        this.exists = function () {
            var _a;
            var value = _this.storage_().getItem(_this.storageKey_);
            var result = ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0) > 0;
            return result;
        };
        this.save = function (value) {
            if (isNotNullish(value)) {
                _this.storage_().setItem(_this.storageKey_, _this.serialize_(value));
            }
            else {
                _this.storage_().removeItem(_this.storageKey_);
            }
        };
        this.storage_ = options.storage;
        this.storageKey_ = options.storageKey;
        this.serialize_ = options.serialize;
        this.deserialize_ = options.deserialize;
    }
    return AuthStorageWrapper;
}());

var AuthEventBus = /** @class */ (function () {
    function AuthEventBus(initialValue) {
        var _this = this;
        this.event$ = new rxjs.BehaviorSubject(undefined);
        this.observe = function () {
            return _this.event$;
        };
        this.send = function (data) {
            _this.event$.next(data !== null && data !== void 0 ? data : null);
        };
        this.event$.next(initialValue);
    }
    return AuthEventBus;
}());

var createEventBus = function (initialValue) {
    return new AuthEventBus(initialValue);
};
var createStorage = function (options) {
    var opts = __assign({ serialize: JSON.stringify, deserialize: JSON.parse }, options);
    return new AuthStorageWrapper(opts);
};
var Authentication = {
    StorageWrapper: AuthStorageWrapper,
    createEventBus: createEventBus,
    createStorage: createStorage,
};

function splitParams(params) {
    var ctx = params.ctx, header = params.header, rest = __rest(params, ["ctx", "header"]);
    return [rest, { ctx: ctx, header: header }];
}

var createAppError = function (error) {
    var _a;
    console.log('error=', error);
    if (error.isAxiosError && error.message === 'Network Error') {
        console.log('axiosError', error.toJSON());
        return new AppError('E1_NETWORK_ERROR');
    }
    if (error instanceof AppError || error instanceof ApiCanceledError) {
        return error;
    }
    if (axios.isCancel(error)) {
        return new ApiCanceledError();
    }
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) > 0) {
        return new AppError("E1_HTTP_".concat(error.response.status));
    }
    return new AppError('E1_UNKNOWN', error.message || 'unknwon error');
};
var AppError = /** @class */ (function (_super) {
    __extends(AppError, _super);
    function AppError(errorCode, message) {
        var _this = _super.call(this, message) || this;
        _this.toString = function () {
            if (_this.message) {
                return "".concat(_this.errorCode, ": ").concat(_this.message);
            }
            else {
                return _this.errorCode;
            }
        };
        _this.errorCode = errorCode;
        _this.name = 'AppError';
        return _this;
    }
    return AppError;
}(Error));
var ApiCanceledError = /** @class */ (function (_super) {
    __extends(ApiCanceledError, _super);
    function ApiCanceledError(message) {
        return _super.call(this, 'E1_CANCELED', message) || this;
    }
    return ApiCanceledError;
}(AppError));

function createCommonjsModule(fn) {
  // eslint-disable-next-line @next/next/no-assign-module-variable
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function M() { this._events = {}; }
M.prototype = {
  on: function(ev, cb) {
    this._events || (this._events = {});
    var e = this._events;
    (e[ev] || (e[ev] = [])).push(cb);
    return this;
  },
  removeListener: function(ev, cb) {
    var e = this._events[ev] || [], i;
    for(i = e.length-1; i >= 0 && e[i]; i--){
      if(e[i] === cb || e[i].cb === cb) { e.splice(i, 1); }
    }
  },
  removeAllListeners: function(ev) {
    if(!ev) { this._events = {}; }
    else { this._events[ev] && (this._events[ev] = []); }
  },
  listeners: function(ev) {
    return (this._events ? this._events[ev] || [] : []);
  },
  emit: function(ev) {
    this._events || (this._events = {});
    var args = Array.prototype.slice.call(arguments, 1), i, e = this._events[ev] || [];
    for(i = e.length-1; i >= 0 && e[i]; i--){
      e[i].apply(this, args);
    }
    return this;
  },
  when: function(ev, cb) {
    return this.once(ev, cb, true);
  },
  once: function(ev, cb, when) {
    if(!cb) return this;
    function c() {
      if(!when) this.removeListener(ev, c);
      if(cb.apply(this, arguments) && when) this.removeListener(ev, c);
    }
    c.cb = cb;
    this.on(ev, c);
    return this;
  }
};
M.mixin = function(dest) {
  var o = M.prototype, k;
  for (k in o) {
    o.hasOwnProperty(k) && (dest.prototype[k] = o[k]);
  }
};
var microee = M;

// Implements a subset of Node's stream.Transform - in a cross-platform manner.
function Transform() {}

microee.mixin(Transform);

// The write() signature is different from Node's
// --> makes it much easier to work with objects in logs.
// One of the lessons from v1 was that it's better to target
// a good browser rather than the lowest common denominator
// internally.
// If you want to use external streams, pipe() to ./stringify.js first.
Transform.prototype.write = function(name, level, args) {
  this.emit('item', name, level, args);
};

Transform.prototype.end = function() {
  this.emit('end');
  this.removeAllListeners();
};

Transform.prototype.pipe = function(dest) {
  var s = this;
  // prevent double piping
  s.emit('unpipe', dest);
  // tell the dest that it's being piped to
  dest.emit('pipe', s);

  function onItem() {
    dest.write.apply(dest, Array.prototype.slice.call(arguments));
  }
  function onEnd() { !dest._isStdio && dest.end(); }

  s.on('item', onItem);
  s.on('end', onEnd);

  s.when('unpipe', function(from) {
    var match = (from === dest) || typeof from == 'undefined';
    if(match) {
      s.removeListener('item', onItem);
      s.removeListener('end', onEnd);
      dest.emit('unpipe');
    }
    return match;
  });

  return dest;
};

Transform.prototype.unpipe = function(from) {
  this.emit('unpipe', from);
  return this;
};

Transform.prototype.format = function(dest) {
  throw new Error([
    'Warning: .format() is deprecated in Minilog v2! Use .pipe() instead. For example:',
    'var Minilog = require(\'minilog\');',
    'Minilog',
    '  .pipe(Minilog.backends.console.formatClean)',
    '  .pipe(Minilog.backends.console);'].join('\n'));
};

Transform.mixin = function(dest) {
  var o = Transform.prototype, k;
  for (k in o) {
    o.hasOwnProperty(k) && (dest.prototype[k] = o[k]);
  }
};

var transform = Transform;

// default filter


var levelMap = { debug: 1, info: 2, warn: 3, error: 4 };

function Filter() {
  this.enabled = true;
  this.defaultResult = true;
  this.clear();
}

transform.mixin(Filter);

// allow all matching, with level >= given level
Filter.prototype.allow = function(name, level) {
  this._white.push({ n: name, l: levelMap[level] });
  return this;
};

// deny all matching, with level <= given level
Filter.prototype.deny = function(name, level) {
  this._black.push({ n: name, l: levelMap[level] });
  return this;
};

Filter.prototype.clear = function() {
  this._white = [];
  this._black = [];
  return this;
};

function test(rule, name) {
  // use .test for RegExps
  return (rule.n.test ? rule.n.test(name) : rule.n == name);
}
Filter.prototype.test = function(name, level) {
  var i, len = Math.max(this._white.length, this._black.length);
  for(i = 0; i < len; i++) {
    if(this._white[i] && test(this._white[i], name) && levelMap[level] >= this._white[i].l) {
      return true;
    }
    if(this._black[i] && test(this._black[i], name) && levelMap[level] <= this._black[i].l) {
      return false;
    }
  }
  return this.defaultResult;
};

Filter.prototype.write = function(name, level, args) {
  if(!this.enabled || this.test(name, level)) {
    return this.emit('item', name, level, args);
  }
};

var filter = Filter;

var minilog$1 = createCommonjsModule(function (module, exports) {
var log = new transform(),
    slice = Array.prototype.slice;

exports = module.exports = function create(name) {
  var o   = function() { log.write(name, undefined, slice.call(arguments)); return o; };
  o.debug = function() { log.write(name, 'debug', slice.call(arguments)); return o; };
  o.info  = function() { log.write(name, 'info',  slice.call(arguments)); return o; };
  o.warn  = function() { log.write(name, 'warn',  slice.call(arguments)); return o; };
  o.error = function() { log.write(name, 'error', slice.call(arguments)); return o; };
  o.log   = o.debug; // for interface compliance with Node and browser consoles
  o.suggest = exports.suggest;
  o.format = log.format;
  return o;
};

// filled in separately
exports.defaultBackend = exports.defaultFormatter = null;

exports.pipe = function(dest) {
  return log.pipe(dest);
};

exports.end = exports.unpipe = exports.disable = function(from) {
  return log.unpipe(from);
};

exports.Transform = transform;
exports.Filter = filter;
// this is the default filter that's applied when .enable() is called normally
// you can bypass it completely and set up your own pipes
exports.suggest = new filter();

exports.enable = function() {
  if(exports.defaultFormatter) {
    return log.pipe(exports.suggest) // filter
              .pipe(exports.defaultFormatter) // formatter
              .pipe(exports.defaultBackend); // backend
  }
  return log.pipe(exports.suggest) // filter
            .pipe(exports.defaultBackend); // formatter
};
});

var hex = {
  black: '#000',
  red: '#c23621',
  green: '#25bc26',
  yellow: '#bbbb00',
  blue:  '#492ee1',
  magenta: '#d338d3',
  cyan: '#33bbc8',
  gray: '#808080',
  purple: '#708'
};
function color(fg, isInverse) {
  if(isInverse) {
    return 'color: #fff; background: '+hex[fg]+';';
  } else {
    return 'color: '+hex[fg]+';';
  }
}

var util = color;

var colors$1 = { debug: ['cyan'], info: ['purple' ], warn: [ 'yellow', true ], error: [ 'red', true ] },
    logger$4 = new transform();

logger$4.write = function(name, level, args) {
  var fn = console.log;
  if(console[level] && console[level].apply) {
    fn = console[level];
    fn.apply(console, [ '%c'+name+' %c'+level, util('gray'), util.apply(util, colors$1[level])].concat(args));
  }
};

// NOP, because piping the formatted logs can only cause trouble.
logger$4.pipe = function() { };

var color_1 = logger$4;

var colors = { debug: ['gray'], info: ['purple' ], warn: [ 'yellow', true ], error: [ 'red', true ] },
    logger$3 = new transform();

logger$3.write = function(name, level, args) {
  var fn = console.log;
  if(level != 'debug' && console[level]) {
    fn = console[level];
  }

  var i = 0;
  if(level != 'info') {
    for(; i < args.length; i++) {
      if(typeof args[i] != 'string') break;
    }
    fn.apply(console, [ '%c'+name +' '+ args.slice(0, i).join(' '), util.apply(util, colors[level]) ].concat(args.slice(i)));
  } else {
    fn.apply(console, [ '%c'+name, util.apply(util, colors[level]) ].concat(args));
  }
};

// NOP, because piping the formatted logs can only cause trouble.
logger$3.pipe = function() { };

var minilog = logger$3;

var newlines = /\n+$/,
    logger$2 = new transform();

logger$2.write = function(name, level, args) {
  var i = args.length-1;
  if (typeof console === 'undefined' || !console.log) {
    return;
  }
  if(console.log.apply) {
    return console.log.apply(console, [name, level].concat(args));
  } else if(JSON && JSON.stringify) {
    // console.log.apply is undefined in IE8 and IE9
    // for IE8/9: make console.log at least a bit less awful
    if(args[i] && typeof args[i] == 'string') {
      args[i] = args[i].replace(newlines, '');
    }
    try {
      for(i = 0; i < args.length; i++) {
        args[i] = JSON.stringify(args[i]);
      }
    } catch(e) {}
    console.log(args.join(' '));
  }
};

logger$2.formatters = ['color', 'minilog'];
logger$2.color = color_1;
logger$2.minilog = minilog;

var console_1 = logger$2;

var cache$1 = [ ];

var logger$1 = new transform();

logger$1.write = function(name, level, args) {
  cache$1.push([ name, level, args ]);
};

// utility functions
logger$1.get = function() { return cache$1; };
logger$1.empty = function() { cache$1 = []; };

var array = logger$1;

var cache = false;

var logger = new transform();

logger.write = function(name, level, args) {
  if(typeof window == 'undefined' || typeof JSON == 'undefined' || !JSON.stringify || !JSON.parse) return;
  try {
    if(!cache) { cache = (window.localStorage.minilog ? JSON.parse(window.localStorage.minilog) : []); }
    cache.push([ new Date().toString(), name, level, args ]);
    window.localStorage.minilog = JSON.stringify(cache);
  } catch(e) {}
};

var localstorage = logger;

var cid = new Date().valueOf().toString(36);

function AjaxLogger(options) {
  this.url = options.url || '';
  this.cache = [];
  this.timer = null;
  this.interval = options.interval || 30*1000;
  this.enabled = true;
  this.jQuery = window.jQuery;
  this.extras = {};
}

transform.mixin(AjaxLogger);

AjaxLogger.prototype.write = function(name, level, args) {
  if(!this.timer) { this.init(); }
  this.cache.push([name, level].concat(args));
};

AjaxLogger.prototype.init = function() {
  if(!this.enabled || !this.jQuery) return;
  var self = this;
  this.timer = setTimeout(function() {
    var i, logs = [], ajaxData, url = self.url;
    if(self.cache.length == 0) return self.init();
    // Test each log line and only log the ones that are valid (e.g. don't have circular references).
    // Slight performance hit but benefit is we log all valid lines.
    for(i = 0; i < self.cache.length; i++) {
      try {
        JSON.stringify(self.cache[i]);
        logs.push(self.cache[i]);
      } catch(e) { }
    }
    if(self.jQuery.isEmptyObject(self.extras)) {
        ajaxData = JSON.stringify({ logs: logs });
        url = self.url + '?client_id=' + cid;
    } else {
        ajaxData = JSON.stringify(self.jQuery.extend({logs: logs}, self.extras));
    }

    self.jQuery.ajax(url, {
      type: 'POST',
      cache: false,
      processData: false,
      data: ajaxData,
      contentType: 'application/json',
      timeout: 10000
    }).success(function(data, status, jqxhr) {
      if(data.interval) {
        self.interval = Math.max(1000, data.interval);
      }
    }).error(function() {
      self.interval = 30000;
    }).always(function() {
      self.init();
    });
    self.cache = [];
  }, this.interval);
};

AjaxLogger.prototype.end = function() {};

// wait until jQuery is defined. Useful if you don't control the load order.
AjaxLogger.jQueryWait = function(onDone) {
  if(typeof window !== 'undefined' && (window.jQuery || window.$)) {
    return onDone(window.jQuery || window.$);
  } else if (typeof window !== 'undefined') {
    setTimeout(function() { AjaxLogger.jQueryWait(onDone); }, 200);
  }
};

var jquery_simple = AjaxLogger;

var web = createCommonjsModule(function (module, exports) {
var oldEnable = minilog$1.enable,
    oldDisable = minilog$1.disable,
    isChrome = (typeof navigator != 'undefined' && /chrome/i.test(navigator.userAgent));

// Use a more capable logging backend if on Chrome
minilog$1.defaultBackend = (isChrome ? console_1.minilog : console_1);

// apply enable inputs from localStorage and from the URL
if(typeof window != 'undefined') {
  try {
    minilog$1.enable(JSON.parse(window.localStorage['minilogSettings']));
  } catch(e) {}
  if(window.location && window.location.search) {
    var match = RegExp('[?&]minilog=([^&]*)').exec(window.location.search);
    match && minilog$1.enable(decodeURIComponent(match[1]));
  }
}

// Make enable also add to localStorage
minilog$1.enable = function() {
  oldEnable.call(minilog$1, true);
  try { window.localStorage['minilogSettings'] = JSON.stringify(true); } catch(e) {}
  return this;
};

minilog$1.disable = function() {
  oldDisable.call(minilog$1);
  try { delete window.localStorage.minilogSettings; } catch(e) {}
  return this;
};

exports = module.exports = minilog$1;

exports.backends = {
  array: array,
  browser: minilog$1.defaultBackend,
  localStorage: localstorage,
  jQuery: jquery_simple
};
});

web.enable();
var log = web('domain');

var createApiServer = function (apiBaseURL, responseInterceptor, errorResponseInterceptor, debug) {
    if (debug === void 0) { debug = true; }
    var server = axios.create({
        baseURL: apiBaseURL,
        //withCredentials: false,
    });
    server.defaults.timeout = 30000; // 15sec
    server.interceptors.request.use(function (config) {
        if (debug) {
            log.debug("axios interceptors ".concat(config.method, "url="), config.url, {
                headers: config.headers,
            });
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    server.interceptors.response.use(responseInterceptor, function (error) {
        if (axios.isCancel(error)) {
            log.debug('axios canceled');
        }
        log.debug('axios.interceptors.response error', error);
        var appError = createAppError(error);
        if (errorResponseInterceptor) {
            errorResponseInterceptor(appError);
        }
        return Promise.reject(appError);
    });
    return server;
};
var serialize = function (params, clean) {
    if (clean === void 0) { clean = true; }
    if (!params || Object.keys(params).length === 0)
        return undefined;
    if (clean) {
        var newParams = {};
        for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
            var key = _a[_i];
            if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
                newParams[key] = params[key];
            }
        }
        if (Object.keys(newParams).length === 0) {
            return undefined;
        }
        return qs.stringify(newParams);
    }
    else {
        return qs.stringify(params);
    }
};
// makeGetUrl('/', {foo: 123, bar: null},      false)= /?foo=123&bar=
// makeGetUrl('/', {foo: 123, bar: null},      true) = /?foo=123
// makeGetUrl('/', {foo: 123, bar: undefined}, true) = /?foo=123
// makeGetUrl('/', {foo: 123, bar: ''},        true) = /?foo=123
// makeGetUrl('/', {foo: 123, bar: 0},         true) = /?foo=123&bar=0
var makeGetUrl = function (url, params, clean) {
    var _a;
    if (clean === void 0) { clean = true; }
    if (!params || Object.keys(params).length === 0)
        return url;
    var queryStr = (_a = serialize(params, clean)) !== null && _a !== void 0 ? _a : '';
    var prefix = url.endsWith('?') || url.endsWith('&') ? '' : url.indexOf('?') < 0 ? '?' : '&';
    return "".concat(url).concat(prefix).concat(queryStr);
};
var createCancelToken = function () {
    var source = axios.CancelToken.source();
    var token = source.token, cancel = source.cancel;
    return { token: token, cancel: cancel };
};
function wrapAxiosResponse(ctx, extraHeaders, createApiHeader, handle) {
    return __awaiter(this, void 0, void 0, function () {
        var headers, config, _a, token, cancel_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    headers = __assign(__assign({}, extraHeaders), createApiHeader());
                    config = __assign({}, ctx === null || ctx === void 0 ? void 0 : ctx.config);
                    config.headers = headers;
                    if (ctx) {
                        _a = createCancelToken(), token = _a.token, cancel_1 = _a.cancel;
                        ctx.cancel = function (message) {
                            ctx.canceled = true;
                            cancel_1(message);
                        };
                        config.cancelToken = token;
                    }
                    return [4 /*yield*/, handle(config)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
var convertApiResponse = function (errorToMessage) {
    return function (axiosResponse) {
        var apiResponse = axiosResponse.data;
        var _a = apiResponse !== null && apiResponse !== void 0 ? apiResponse : {}, _b = _a.success, success = _b === void 0 ? false : _b, _c = _a.errorCode, errorCode = _c === void 0 ? 'E1_UNKNOWN' : _c, _d = _a.message, message = _d === void 0 ? '' : _d;
        if (success) {
            return apiResponse;
        }
        if (errorCode === 'E1_CUSTOM' && message.length > 0) {
            throw new AppError(errorCode, message);
        }
        var msg = errorToMessage(errorCode);
        throw new AppError(errorCode, msg);
    };
};
// const toApiResponseData = <T>(axiosResponse: AxiosResponse): T => {
//   const response = toApiResponse(axiosResponse) as ApiResponseWithData<T>
//   return response.data
// }
var withResponseBody = function (response) {
    log.debug('withResponseBody', response);
    return response.body;
};
var ApiHelper = /** @class */ (function () {
    function ApiHelper(apiBaseURL,
    // eslint-disable-next-line no-unused-vars
    createApiHeader,
    // 인증 헤더를 처리할 Reponse interceptor
    responseInterceptor, errorResponseInterceptor, errorToMessage, debug) {
        if (debug === void 0) { debug = true; }
        var _this = this;
        this.apiBaseURL = apiBaseURL;
        this.createApiHeader = createApiHeader;
        this._get = function (url, params, extraHeaders, ctx) {
            // if (DEBUG_API) console.log('ApiHelper _get request=', url, params ?? '')
            var urlWithQuery = makeGetUrl(url, params);
            return wrapAxiosResponse(ctx, extraHeaders, _this.createApiHeader, function (config) {
                return _this.server.get(urlWithQuery, config);
            });
        };
        this._post = function (url, params, extraHeaders, ctx) {
            // if (DEBUG_API) console.log('ApiHelper _post request=', url, params ?? '', extraHeaders)
            return wrapAxiosResponse(ctx, extraHeaders, _this.createApiHeader, function (config) {
                return _this.server.post(url, params, config);
            });
        };
        this.get = function (url, params, extra) {
            var extraHeaders = extra === null || extra === void 0 ? void 0 : extra.header;
            return _this._get(url, params, extraHeaders, extra === null || extra === void 0 ? void 0 : extra.ctx).then(_this.toApiResponse_);
        };
        this.post = function (url, params, extra) {
            var defaultHeader = { 'Content-Type': 'application/x-www-form-urlencoded' };
            var extraHeaders = (extra === null || extra === void 0 ? void 0 : extra.header) ? __assign(__assign({}, defaultHeader), extra === null || extra === void 0 ? void 0 : extra.header) : defaultHeader;
            return _this._post(url, serialize(params), extraHeaders, extra === null || extra === void 0 ? void 0 : extra.ctx).then(_this.toApiResponse_);
        };
        this.postJson = function (url, params, extra) {
            var defaultHeader = { 'Content-Type': 'application/json' };
            var extraHeaders = (extra === null || extra === void 0 ? void 0 : extra.header) ? Object.assign({}, defaultHeader, extra === null || extra === void 0 ? void 0 : extra.header) : defaultHeader;
            return _this._post(url, params, extraHeaders, extra === null || extra === void 0 ? void 0 : extra.ctx).then(_this.toApiResponse_);
        };
        this.postMultipart = function (url, formData, extra) {
            var defaultHeader = { 'Content-Type': 'multipart/form-data' };
            var extraHeaders = (extra === null || extra === void 0 ? void 0 : extra.header) ? Object.assign({}, defaultHeader, extra === null || extra === void 0 ? void 0 : extra.header) : defaultHeader;
            return _this._post(url, formData, extraHeaders, extra === null || extra === void 0 ? void 0 : extra.ctx).then(_this.toApiResponse_);
        };
        this.server = createApiServer(apiBaseURL, responseInterceptor, errorResponseInterceptor, debug);
        this.toApiResponse_ = convertApiResponse(errorToMessage).bind(this);
    }
    return ApiHelper;
}());
var ApiHelperWithData = /** @class */ (function () {
    function ApiHelperWithData(helper) {
        var _this = this;
        this.get = function (url, params, extra) {
            return _this.helper.get(url, params, extra).then(function (it) { return withResponseBody(it); });
        };
        this.post = function (url, params, extra) {
            return _this.helper.post(url, params, extra).then(function (it) { return withResponseBody(it); });
        };
        this.postJson = function (url, params, extra) {
            return _this.helper.postJson(url, params, extra).then(function (it) { return withResponseBody(it); });
        };
        this.postMultipart = function (url, formData, extra) {
            return _this.helper.postMultipart(url, formData, extra).then(function (it) { return withResponseBody(it); });
        };
        this.helper = helper;
    }
    return ApiHelperWithData;
}());

exports.ApiCanceledError = ApiCanceledError;
exports.ApiHelper = ApiHelper;
exports.ApiHelperWithData = ApiHelperWithData;
exports.AppError = AppError;
exports.Authentication = Authentication;
exports.createAppError = createAppError;
exports.splitParams = splitParams;
